import { notification } from "antd";
import { getFeatureFlag } from "../util/APIUtils";
import { SET_HEAVY_PARCEL_CONSOLIDATION_V1_FLAG, SET_USE_CORE_RATES_FLAG } from "./types";

export const setHeavyParcelConsolidationV1FeatureFlag = () => async (dispatch) => {
  try {
    let promise = getFeatureFlag("heavy-parcel-consolidation-v1");
    let { enabled } = await promise;
    dispatch({
      type: SET_HEAVY_PARCEL_CONSOLIDATION_V1_FLAG,
      payload: { value: enabled },
    });
  } catch (error) {
    notification.error({
      placement: "topRight",
      duration: null,
      message: "Failed to grab feature flag",
      description: error.message,
    });
  }
};

export const setUseCoreRatesFeatureFlag = () => async (dispatch) => {
  try {
    let promise = getFeatureFlag("use-core-rates");
    let { enabled } = await promise;
    dispatch({
      type: SET_USE_CORE_RATES_FLAG,
      payload: { value: enabled },
    });
  } catch (error) {
    notification.error({
      placement: "topRight",
      duration: null,
      message: "Failed to grab feature flag",
      description: error.message,
    });
  }
};
